import { MockPath } from '@library/common/http/mock-path.mock';

export const ShipmentRoutes: MockPath<unknown>[] = [
   { path: 'shipment/book', verb: 'POST', collection: () => [ '123456789' ] },
];
